import React, { Component } from 'react'
import './NavigationBar.css'
import { Nav, Navbar, NavItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import logo from '../../img/countplus-rip.png'

class NavigationBar extends Component {
  static defaultProps = {
    menuItems: [
      { text: 'Üdvözlés', to: '/home/welcome', spiedElementId: 'welcome' },
      { text: 'Referenciák', to: '/home/references', spiedElementId: 'references' },
      { text: 'Blog', to: '/home/blog', spiedElementId: 'blog' },
      { text: 'Munkatársak', to: '/home/employes', spiedElementId: 'employes' },
      { text: 'Kapcsolat', to: '/home/footer', spiedElementId: 'footer' },
    ]
  };

  render() {
    return (
      <Navbar className='navbar-fixed-top'
        collapseOnSelect={true}
      >
      <span className="feng-shui" />
        <Navbar.Header>
          <Navbar.Brand>
              <span className="navbar-brand-container">
                <img alt="Countplus Kft." src={logo} />
                <div className="navbar-brand-title">Count<span className="navbar-brand-grey">plus Kft.</span></div>
              </span>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            {this.props.menuItems.map((menuItem, i) =>
              <LinkContainer key={i} to={menuItem.to}>
                <NavItem eventKey={i}>{menuItem.text}</NavItem>
              </LinkContainer>
            )}
          </Nav>
          <Nav pullRight>
            <LinkContainer to="/partner">
              <NavItem eventKey={99} >Partnereinknek</NavItem>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export default NavigationBar



// WEBPACK FOOTER //
// ./src/containers/navigationbar/NavigationBar.js